const machine_txt = {
    type: "VA-W600D",
    name: "Smaller Cylinder Bed Includes New Features Designed Specifically For Ease Of Operation",
    description: [
        "Common Specifications",
        "Cylinder bed, interlock stitch machines",
        "Stitch length adjustment : Dial",
        "Differential feed ratio adjustment:",
        "Lever that can be adjusted intermittently during sewing",
        "Maximum speed : 5,000 sti/min",
        "Lubrication : Fully-automatic",
        "Functional Characteristics",
        "The 270mm cylinder circumference is suitable for sewing small tubular parts, such as neck openings or arm holes of children's wear. You can handle the fabric easily. Numerous subclasses available for tubular knit fabrics respond well to a wide variety of fabrics, with dramatic increase in quality,efficiency and production.",
        "Super cost-effectiveSuperior spare parts supply system and superior versatility of spare parts make it more cost-effective, better close to the market and bring excellent products to end customers.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/9/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/9/machine_other/1.png",
        "/assets/machine/9/machine_other/2.png",
    ]
}
export default {machine_txt}